export default function KelebihanPendana(){
    return(
        <div className='container-alur'>
            <h2 className='text-header'>Kelebihan Menjadi Pemberi Pinjaman di <span>Danai.id</span></h2>
            <div className='kelebihan-pendana'>
                <div className='section'>
                    <img src={require('../../../../assets/img/product/pendanaan-1.png')} alt='pendanaan-1'/>
                    <p>Imbal hasil (bunga) lebih menarik dari <u>alternatif pendanaan lain.</u></p>
                </div>
                <div className='section'>
                    <img src={require('../../../../assets/img/product/pendanaan-2.png')} alt='pendanaan-2'/>
                    <p>Pendanaan mulai dari Rp 100.000,-</p>
                </div>
                <div className='section'>
                    <img src={require('../../../../assets/img/product/pendanaan-3.png')} alt='pendanaan-3'/>
                    <p>Imbal hasil (bunga) dapat dinikmati secara bulanan ataupun tempo pinjaman yang tertentu.</p>
                </div>
                <div className='section'>
                    <img src={require('../../../../assets/img/product/pendanaan-4.png')}
                         alt='pendanaan-4'/>
                    <p>Tahapan resiko yang terukur dan dapat di atur sesuai preferensi, dan dapat memilih pinjaman yang terproteksi.</p>
                </div>
            </div>
            <div className='info-section-pendanaan'>
                <p>Siapa saja dapat menjadi Pemberi Pinjaman di platform Danai.id sebagai pendana secara Individu maupun Badan Hukum.</p>
            </div>
        </div>
    );
}